// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__f55jv","logo":"Header_logo__9YFPc"};